import Api from '@/services/Api';

export default {
  login(params: any) {
    return Api().post('/admin/login', params);
  },
  changePassword(params: any) {
    return Api().post('/admin/changePassword', params);
  },
};
